import { type ComponentProps } from 'react'
import clsx from 'clsx'
import { motion, type Transition, type Variants } from 'motion/react'
import { AnimatePresence } from 'motion/react'
import { Price } from '@/components/Price'
import { getSummarisedPrice } from '@/utils/getOfferPrice'
import { type Text } from 'ui/src/components/Text/Text'
import { framerTransitions } from 'ui/src/theme/transitions'
import { useSelectedOffer } from '../../PurchaseForm/useSelectedOffer'
import { priceLabel, priceWrapper } from './SelectedOfferAnimatedPrice.css'

const TRAVEL_DISTANCE = '1em'
const ANIMATION: Variants = {
  pushDown: { y: TRAVEL_DISTANCE, opacity: 0 },
  original: { y: 0, opacity: 1 },
  pushUp: { y: `-${TRAVEL_DISTANCE}`, opacity: 0 },
}
const TRANSITION: Transition = { duration: 0.3, ...framerTransitions.easeInOutCubic }

type Props = ComponentProps<'div'> & {
  color?: ComponentProps<typeof Text>['color']
}

export function SelectedOfferAnimatedPrice({ className, ...props }: Props) {
  const [selectedOffer] = useSelectedOffer()

  if (!selectedOffer) {
    return null
  }

  const { currencyCode, amount, reducedAmount } = getSummarisedPrice(selectedOffer.cost)

  return (
    <div className={clsx(priceWrapper, className)} {...props}>
      <AnimatePresence initial={false}>
        <motion.div
          key={selectedOffer.id}
          className={priceLabel}
          transition={TRANSITION}
          variants={ANIMATION}
          initial="pushDown"
          animate="original"
          exit="pushUp"
        >
          <Price currencyCode={currencyCode} amount={amount} reducedAmount={reducedAmount} />
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
